import { TipoRequerimento } from './TipoRequerimento';
import { Checklist } from './Checklist';
import { TipoRequerenteReqEnum } from './enums/TipoRequerenteReqEnum';
import { TipoDocumentoEnum } from './enums/TipoDocumentoEnum';
import { SituacaoRequerimentoEnum } from './enums/SituacaoRequerimentoEnum';
import { ModoEnum } from './enums/ModoEnum';
var Requerimento = /** @class */ (function () {
    function Requerimento() {
        this.parcelasImovelConcedido = [];
        this.origemCadastro = ModoEnum.ONLINE;
        this.parcelasImovel = [];
        this.anexos = [];
        this.abaFormulario = 0;
        this.requerimentoInventariante = null;
        this.situacao = SituacaoRequerimentoEnum.PREENCHIMENTO_EM_ABERTO;
        this.tipoRequerente = TipoRequerenteReqEnum.REQUERENTE;
        this.tipoRequerimentoDoc = TipoDocumentoEnum.PF;
        this.tipoRequerimento = new TipoRequerimento();
        this.requerentePf = null;
        this.requerentePj = null;
        this.procurador = null;
        this.numeroRequerimento = 'TMP_000';
        this.checklist = new Checklist();
        this.descricaoServico = '';
        this.nomeServico = '';
        this.gratuidade = null;
    }
    return Requerimento;
}());
export { Requerimento };
